import React from 'react';
import Icon from '../../../components/AppIcon';

const SEOScoreCard = ({ score, title, status, trend, details }) => {
  const getScoreColor = (score) => {
    if (score >= 80) return 'text-green-600';
    if (score >= 60) return 'text-amber-600';
    return 'text-red-600';
  };

  const getStatusColor = (status) => {
    if (status === 'excellent') return 'bg-green-100 text-green-700';
    if (status === 'good') return 'bg-blue-100 text-blue-700';
    if (status === 'warning') return 'bg-amber-100 text-amber-700';
    return 'bg-red-100 text-red-700';
  };

  const getTrendIcon = (trend) => {
    if (trend === 'up') return { name: 'TrendingUp', color: 'text-green-600' };
    if (trend === 'down') return { name: 'TrendingDown', color: 'text-red-600' };
    return { name: 'Minus', color: 'text-gray-400' };
  };

  const trendInfo = getTrendIcon(trend);

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 md:p-6 hover:shadow-md transition-shadow duration-200">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="text-sm md:text-base font-medium text-gray-700 mb-1">{title}</h3>
          <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(status)}`}>
            {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Icon name={trendInfo?.name} size={20} className={trendInfo?.color} />
        </div>
      </div>
      <div className="flex items-end gap-2 mb-4">
        <span className={`text-3xl md:text-4xl font-bold ${getScoreColor(score)}`}>
          {score}
        </span>
        <span className="text-gray-500 text-sm mb-1">/100</span>
      </div>
      {details && details?.length > 0 && (
        <div className="space-y-2 pt-4 border-t border-gray-100">
          {details?.map((detail, index) => (
            <div key={index} className="flex items-center justify-between text-xs md:text-sm">
              <span className="text-gray-600">{detail?.label}</span>
              <span className={`font-medium ${detail?.status === 'pass' ? 'text-green-600' : 'text-red-600'}`}>
                {detail?.value}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SEOScoreCard;